export const BOOLEAN_VALUE_TO_LABEL = {
  true: 'Yes',
  false: 'No',
};

export const BOOLEAN_DROPDOWN_OPTIONS = Object.entries(
  BOOLEAN_VALUE_TO_LABEL,
).map(([key, value]) => ({
  value: key,
  label: value,
}));
